/**
 * État vide explicite indiquant la cause et l'action attendue — EF-NAV-003.
 * Un état vide n'est jamais présenté comme une erreur lorsqu'il résulte d'une
 * action de l'utilisateur.
 */

import type { JSX } from 'preact';

export interface EmptyStateProps {
  readonly title: string;
  readonly body: string;
  readonly action?: JSX.Element | undefined;
}

export function EmptyState(props: EmptyStateProps): JSX.Element {
  return (
    <div class="empty-state">
      <h2 style="margin-top:0;">{props.title}</h2>
      <p>{props.body}</p>
      {props.action}
    </div>
  );
}
